import { Component, inject, signal } from '@angular/core';
import { Api } from '../../services/api';
import { CategoryItems, TagItems } from '../../interface/articles';
import { catchError, of, pipe, tap, timeout } from 'rxjs';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-widgets',
  imports: [
    RouterLink
  ],
  templateUrl: './widgets.html',
  styleUrl: './widgets.css',
})
export class Widgets {
  private api = inject(Api);

  isLoading = signal(false);
  categories = signal<CategoryItems[]>([]);
  tags = signal<TagItems[]>([]);

  private initialized() : void {
    this.isLoading.set(true);

    this.api.getWidgets()
    .pipe(
      timeout(10000),
      catchError(() => of({
        categories: [],
        tags: []
      })),
      tap(() => this.isLoading.set(false))
    )
    .subscribe(obj => {
      this.categories.set(obj.categories);
      this.tags.set(obj.tags);
    });
  }

  ngOnInit() : void {
    this.initialized();
  }
}
